import React, { FC, useState } from "react"
import {
  Box,
  Typography,
  Paper,
  Stack,
  IconButton,
  Collapse,
  Alert,
  CircularProgress,
} from "@mui/material"
import { Edit, ExpandLess } from "@mui/icons-material"
import { useChannelQuery } from "../../services/channels/channelsApi"
import { EditChannelForm } from "./editChannelForm"

interface IChannelHeaderProps {
  channelId: string
}

export const ChannelHeader: FC<IChannelHeaderProps> = ({ channelId }) => {
  const [editFormOpen, setEditFormOpen] = useState(false)
  const {
    currentData: channel,
    isLoading,
    isError,
  } = useChannelQuery(channelId)

  if (isLoading) {
    return <CircularProgress sx={{ mb: 2 }} />
  }

  if (isError) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        Ошибка при загрузке информации о канале
      </Alert>
    )
  }

  if (!channel) {
    return null
  }

  return (
    <Paper sx={{ p: 3, m: 2 }}>
      <Stack spacing={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" component="h1">
            {channel.custom_name || channel.title}
          </Typography>
          <IconButton
            onClick={() => setEditFormOpen(!editFormOpen)}
            aria-label="редактировать канал"
          >
            {editFormOpen ? <ExpandLess /> : <Edit />}
          </IconButton>
        </Box>

        {channel.custom_name && (
          <Typography variant="body2" color="text.secondary">
            Название канала: {channel.title}
          </Typography>
        )}

        <Typography variant="body2" color="text.secondary">
          ID: {channel.id}
        </Typography>

        {channel.comment && (
          <Typography variant="body1" color="text.primary">
            Примечание: {channel.comment}
          </Typography>
        )}

        <Collapse in={editFormOpen}>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Редактировать канал
            </Typography>
            <EditChannelForm
              channelId={channel.id}
              initialValues={{
                is_hidden: channel.is_hidden,
                custom_name: channel.custom_name,
                comment: channel.comment,
              }}
              onSuccess={() => setEditFormOpen(false)}
            />
          </Box>
        </Collapse>
      </Stack>
    </Paper>
  )
}
